/* eslint-disable max-classes-per-file */
import { BasicEvent } from "../../../planera/events/BasicEvent";

export class ArbetsorderMapHoverInMessage extends BasicEvent {
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderMapHoverInMessage";
    constructor(arbetsorderId: number) {
        super(ArbetsorderMapHoverInMessage.$type);
        this.arbetsorderId = arbetsorderId;
    }
}

export class ArbetsorderMapHoverOutMessage extends BasicEvent {
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderMapHoverOutMessage";
    constructor(arbetsorderId) {
        super(ArbetsorderMapHoverOutMessage.$type);
        this.arbetsorderId = arbetsorderId;
    }
}

export class ArbetsorderListHoverInMessage extends BasicEvent {
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderListHoverInMessage";
    constructor(arbetsorderId: number) {
        super(ArbetsorderListHoverInMessage.$type);
        this.arbetsorderId = arbetsorderId;
    }
}

export class ArbetsorderListHoverOutMessage extends BasicEvent {
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderListHoverOutMessage";
    constructor(arbetsorderId) {
        super(ArbetsorderListHoverOutMessage.$type);
        this.arbetsorderId = arbetsorderId;
    }
}
